module.exports = __webpack_public_path__ + "static/media/social6.6d9c1965.png";